import AdminCrewReportPanel from "../components/crew-report/AdminCrewReportPanel";

const AdminCrewReportPage = () => {
  return <AdminCrewReportPanel />;
};

export default AdminCrewReportPage;
